export enum CheckExpand {
	BalanceFeature = "balance.feature",
	FlagFeature = "flag.feature",
}
